// Bulletin Board block schema - Structured announcement / flyer card
export const bulletinBoardSchema = {
  type: 'bulletin-board',
  label: 'Bulletin Board',
  description: 'Structured announcement or flyer — edit the template freely',
  icon: 'ClipboardList',
  defaultContent: {
    heading: '',
    body: `What: Weekly Blitz Night\n\nWhere: Main Hall, Room 204\n\nWhen: Every Thursday, 7:00 PM\n\nWhat to Bring: Chess clock, notebook\n\nCost: Free for members\n\nContact: coach@example.com\n\nNotes: Beginners welcome!`,
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Optional heading' },
    { name: 'body', label: 'Body', type: 'textarea' },
  ],
};
